import { useFormik } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";
import CustomInput from "../../Common/CustomInput/CustomInput";
import PhoneInput from "react-phone-input-2";
import { useDispatch } from "react-redux";
import { addDriver } from "../../../redux/driver/action";
import { useNavigate } from "react-router-dom";
import Spinner from "../../Layouts/Spinner";
import "react-phone-input-2/lib/style.css";

const AddDriver = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const validationSchema = Yup.object({
    first_name: Yup.string().required("First name is required"),
    last_name: Yup.string().required("Last name is required"),
    email_id: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    country_code: Yup.string().required("Country code is required"),
    mobile_number: Yup.string()
      .required("Mobile number is required")
      .matches(/^\d+$/, "Only digits allowed"),
  });

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email_id: "",
      country_code: "+966",
      mobile_number: "",
    },
    validationSchema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    const data = {
      ...values,
    };
    dispatch(addDriver(data, setLoading, navigate));
  };

  return (
    <div className="card-head order-card order-timing">
        <h3 className="pb-3">Add Driver</h3>
      <form onSubmit={formik.handleSubmit} className="form row">
        {/* First Name */}
        <div className="col-md-6">
          <label>First Name</label>
          <CustomInput
            name="first_name"
             placeholder="Enter First Name"
            value={formik.values.first_name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.first_name && formik.errors.first_name && (
            <small className="text-danger">{formik.errors.first_name}</small>
          )}
        </div>

        {/* Last Name */}
        <div className="col-md-6">
          <label>Last Name</label>
          <CustomInput
            name="last_name"
             placeholder="Enter Last Name"
            value={formik.values.last_name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.last_name && formik.errors.last_name && (
            <small className="text-danger">{formik.errors.last_name}</small>
          )}
        </div>

        {/* Email */}
        <div className="col-md-6">
          <label>Email ID</label>
          <CustomInput
            name="email_id"
            type="email"
            placeholder="Enter Email ID"
            value={formik.values.email_id}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.email_id && formik.errors.email_id && (
            <small className="text-danger">{formik.errors.email_id}</small>
          )}
        </div>

        {/* Phone Input */}
        <div className="col-md-6">
          <label>Mobile Number</label>
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-3 col-4 pr-0">
              <PhoneInput
                country={"sa"}
                value={formik.values.country_code}
                onChange={(value, data) => {
                  formik.setFieldValue("country_code", `+${data.dialCode}`);
                }}
                inputProps={{ readOnly: true }}
                inputStyle={{
                  paddingLeft: "38px",
                  paddingRight: "8px",
                  width: "100%",
                  borderRadius: "0.375rem 0 0 0.375rem"
                }}
              />
              {formik.touched.country_code && formik.errors.country_code && (
                <small className="text-danger">{formik.errors.country_code}</small>
              )}
            </div>

            <div className="col-md-9 col-8 pl-0">
              <input
                type="text"
                style={{borderRadius: '0 0.375rem 0.375rem 0'}}
                name="mobile_number"
                className="form-control mobile-input-res"
                placeholder="Mobile number"
                value={formik.values.mobile_number}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.mobile_number && formik.errors.mobile_number && (
                <small className="text-danger">{formik.errors.mobile_number}</small>
              )}
          </div>
        </div>

        {/* Submit Button */}
        <div className="col-12 mt-4">
          <button
            className="submit-btn"
            style={{ width: "max-content" }}
            type="submit"
            disabled={loading}
          >
            {!loading ? "Submit" : <Spinner />}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddDriver;
